__turbopack_context__.v({
  "checkbox": "ThemeSelectorFooter-module-scss-module__N4lqka__checkbox",
  "selected": "ThemeSelectorFooter-module-scss-module__N4lqka__selected",
  "themeItem": "ThemeSelectorFooter-module-scss-module__N4lqka__themeItem",
});
